import { WaitlistApi } from '../generated/apis';
import { createApi } from '../create-api';
import { getApiClientOptions, registerCacheCleaner } from '../client';

let _instance: WaitlistApi | null = null;

// Register cache cleaner for when initApiClient is called
registerCacheCleaner(() => {
  _instance = null;
});

/**
 * Get the Waitlist API instance.
 * Uses lazy initialization and caching.
 */
export const getWaitlistApi = (): WaitlistApi => {
  if (!_instance) {
    _instance = createApi(WaitlistApi, getApiClientOptions());
  }
  return _instance;
};
